import { Badge, Card, Container, Group, SimpleGrid, Stack, Text, ThemeIcon, Title } from '@mantine/core'
import { createFileRoute, Link } from '@tanstack/react-router'
import { useTranslation } from 'react-i18next'
import { LuAnchor, LuBell, LuMail, LuScrollText, LuSettings, LuShieldCheck, LuUsers } from 'react-icons/lu'

export const Route = createFileRoute('/dashboard/settings/')({
  component: SettingsLanding,
})

function SettingsLanding() {
  const { t } = useTranslation()

  const SECTIONS = [
    {
      href: '/dashboard/settings/marina-info',
      icon: LuSettings,
      title: t('page.settings.index.card_marina'),
      desc: t('page.settings.index.card_marina_desc'),
      enabled: true,
      color: 'laut',
    },
    {
      href: '/dashboard/settings/berths',
      icon: LuAnchor,
      title: t('page.settings.index.card_berths'),
      desc: t('page.settings.index.card_berths_desc'),
      enabled: true,
      color: 'blue',
    },
    {
      href: '/dashboard/settings/audit',
      icon: LuScrollText,
      title: t('page.settings.index.card_audit'),
      desc: t('page.settings.index.card_audit_desc'),
      enabled: true,
      color: 'gray',
    },
    {
      href: '/dashboard/settings/staff',
      icon: LuUsers,
      title: t('page.settings.index.card_staff'),
      desc: t('page.settings.index.card_staff_desc'),
      enabled: false,
      color: 'violet',
    },
    {
      href: '/dashboard/settings/email',
      icon: LuMail,
      title: t('page.settings.index.card_email'),
      desc: t('page.settings.index.card_email_desc'),
      enabled: false,
      color: 'orange',
    },
    {
      href: '/dashboard/settings/notifications',
      icon: LuBell,
      title: t('page.settings.index.card_notifications'),
      desc: t('page.settings.index.card_notifications_desc'),
      enabled: false,
      color: 'yellow',
    },
    {
      href: '/dashboard/settings/security',
      icon: LuShieldCheck,
      title: t('page.settings.index.card_security'),
      desc: t('page.settings.index.card_security_desc'),
      enabled: false,
      color: 'red',
    },
  ]

  return (
    <Container size="xl" py="md">
      <Stack gap="lg">
        <Group gap="sm" align="center">
          <ThemeIcon variant="light" color="laut" size="lg" radius="md">
            <LuSettings size={18} />
          </ThemeIcon>
          <div>
            <Title order={2} ff="var(--font-display)" fw={600}>
              {t('page.settings.index.title')}
            </Title>
            <Text size="xs" c="dimmed">
              {t('page.settings.index.subtitle')}
            </Text>
          </div>
        </Group>

        <SimpleGrid cols={{ base: 1, sm: 2, md: 3 }} spacing="sm">
          {SECTIONS.map((s) => {
            const card = (
              <Card
                key={s.href}
                padding="lg"
                radius="md"
                style={{
                  cursor: s.enabled ? 'pointer' : 'not-allowed',
                  opacity: s.enabled ? 1 : 0.55,
                  height: '100%',
                  transition: 'opacity 150ms ease',
                }}
              >
                <Group gap="sm" mb="sm" justify="space-between" align="flex-start">
                  <Group gap="sm">
                    <ThemeIcon variant="light" color={s.enabled ? s.color : 'gray'} size="lg" radius="md">
                      <s.icon size={18} />
                    </ThemeIcon>
                    <Text fw={700} size="sm">
                      {s.title}
                    </Text>
                  </Group>
                  {!s.enabled && (
                    <Badge size="xs" color="gray" variant="light">
                      {t('page.settings.index.badge_soon')}
                    </Badge>
                  )}
                  {s.enabled && (
                    <Badge size="xs" color="teal" variant="light">
                      {t('page.settings.index.badge_active')}
                    </Badge>
                  )}
                </Group>
                <Text size="sm" c="dimmed" lh={1.5}>
                  {s.desc}
                </Text>
              </Card>
            )
            return s.enabled ? (
              <Link key={s.href} to={s.href as any} style={{ textDecoration: 'none', color: 'inherit' }}>
                {card}
              </Link>
            ) : (
              <div key={s.href}>{card}</div>
            )
          })}
        </SimpleGrid>
      </Stack>
    </Container>
  )
}
